<template>
  <div class="app-container" v-show="isLogin">
    <!-- 佣金申请列表 -->
    <el-table
      v-show="this.listQuery.button == 3"
      v-loading="listLoading"
      :data="yjsqList"
      highlight-current-row
      style="color: rgb(70, 70, 70); margin-top: 10px"
      :row-style="{ height: '0' }"
      :cell-style="{ padding: '3px 0' }"
      :header-cell-style="{
        background: 'rgb(247 248 252) !important',
        color: '#ededed  !important',
        padding: '7px 0',
        color: 'rgb(140, 140, 140)',
      }"
    >
      <el-table-column label="手机号" align="left" min-width="2">
        <template slot-scope="{ row }">
          <span>{{ row.phone }}</span>
        </template>
      </el-table-column>
      <el-table-column label="金额" min-width="2" align="left">
        <template slot-scope="{ row }">
          <span>{{ row.price }}</span>
        </template>
      </el-table-column>
      <el-table-column label="备注" min-width="3" align="left">
        <template slot-scope="{ row }">
          <span class="ellipsis" :title="row.ext">{{ row.ext }}</span>
        </template>
      </el-table-column>
      <el-table-column label="处理状态" min-width="1" align="left">
        <template slot-scope="{ row }">
          <span>{{ row.is_handle | handleFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column label="提交时间" min-width="2" align="left">
        <template slot-scope="{ row }">
          <span class="ellipsis" :title="row.updated_at">{{ row.updated_at }}</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="yjsqTotal > 0 && this.listQuery.button == 3"
      :total="yjsqTotal"
      :page.sync="listQuery.page"
      layout="total, prev, pager, next"
      style="padding-top: 12px; padding-bottom: 0px; text-align: center"
      @pagination="getList(3)"
    />
  </div>
</template>

<script>
import Cookies from "js-cookie";
import axios from "axios";
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination

export default {
  name: "dltg",
  components: {
    Pagination,
  },
  filters: {
    // statusFilter(status) {
    //   const statusMap = {
    //     1: "已充值",
    //     0: "未充值",
    //   };
    //   return statusMap[status];
    // },
    handleFilter(status) {
      const handleMap = {
        1: "已处理",
        0: "未处理",
      };
      return handleMap[status];
    },
  },
  data() {
    return {
      isLogin: false,
      yjsqList: [],
      yjsqTotal: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        per_page: 15,
        button: 1,
        status: 0,
      },
      isShow: true,
    };
  },
  created() {
    //判断 登录userToken是否有效 userToken == '' ||
    const userToken = Cookies.get("view_userToken");

    if (userToken == undefined) {
      this.isLogin = false;
      this.$confirm("请先登录再使用！", "提示", {
        confirmButtonText: "确定",
      })
        .then(() => {
          // 重新导航到登录页面
          localStorage.clear();
          this.$root.removeCookies();
          this.$router.push({ path: "/login" });
        })
        .catch(() => {
          // 重新导航到首页
          localStorage.clear();
          this.$root.removeCookies();
          this.$router.push({ path: "/" });
        });
      return;
    } else {
      this.isLogin = true;
    }
    this.getList(3);
  },
  methods: {
    getList(btn) {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.isLogin = false;
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            Cookies.set("view_historyPath", "/dltg", { expires: 1 });
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }

      this.listQuery.button = btn;
      this.yjsqList = [];

      this.listLoading = true;
      const url = this.$root.commonPreUrl + "/index/kami";
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
        params: this.listQuery,
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            if (btn == 3) {
              this.yjsqList = resd.data.data;
              this.yjsqTotal = resd.data.total;
            }
            this.listLoading = false;
          }
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => {});
          }
          return;
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 3 * 1000);
    },
  },
};
</script>

<style>
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
  max-width: 87%;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/views/dltg/txjl/index.vue